// Charge la base commune
// Styles librairies
// import 'bootstrap/scss/_functions';
// import 'bootstrap/scss/_variables';
// import 'bootstrap/scss/_mixins';
// import 'bootstrap/scss/_progress';

// Styles custom
import './scss/pages/credit-demand'

// Scripts librairies
import { pageLoading } from 'js/custom_script'
import { scroll } from './js/libs/misc.js'

require('./common.js')

// Components
let _recaptcha = false
function getByPhoneForm () {
  pageLoading()
  import('./js/components/credit-demand-by-phone-form.js').then(() => {
    focusCaf('#by-phone')
    pageLoading(false)
  })
}

function getOnlineForm () {
  pageLoading()
  import('./js/components/credit-demand-online-form.js').then(() => {
    focusCaf('#online')
    pageLoading(false)
  })
}

function getRdvForm () {
  pageLoading()
  import('./js/components/credit-demand-rdv-form.js').then(() => {
    focusCaf('#rendezvous')
    pageLoading(false)
  })
}

// masque les différents types de demande
function hideCaf () {
  $('.caf').hide()
}

// focus sur un type de demande
function focusCaf (c) {
  hideCaf()
  $(c).show()
  scroll(c)
  $('#recaptcha').appendTo(c + ' .recaptcha-to') // déplace le captcha en cas de multiples captchas
}

// charge recaptcha
function loadRecaptcha () {
  if (!_recaptcha) {
    _recaptcha = true
    const body = document.getElementsByTagName('body')[0]
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://www.google.com/recaptcha/api.js'
    // script.onload = 'testRec'
    body.appendChild(script)
  }
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  if ($('#wdyw').length) {
    const target = $('#wdyw')
    $('html, body').animate({
      scrollTop: ($(target).offset().top - 124) - -1
    }, 500)
  }
  $('.by-phone').on('click', function () {
    hideCaf()
    loadRecaptcha()
    getByPhoneForm()
    $(this).off().on('click', function () {
      focusCaf('#by-phone')
    })
  })
  $('.online').on('click', function () {
    hideCaf()
    loadRecaptcha()
    getOnlineForm()
    $(this).off().on('click', function () {
      focusCaf('#online')
    })
  })
  $('.rendezvous').on('click', function () {
    hideCaf()
    loadRecaptcha()
    getRdvForm()
    $(this).off().on('click', function () {
      focusCaf('#rendezvous')
    })
  })
})
